import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import { DrawStage, isRole } from "@toorak/tc-common-fe-sdk";
import { Grid } from "@mui/material";
import { exportDiscussions } from "../../../stores/drawRequest/drawRequest.action";
import { DrawDiscussionChat } from "../DiscussionChats.Html";
import { RootState } from "../../../stores/rootReducer";
import { DrawRolesEnum } from "../../../utils/constants";
import { isOrigUser } from "../../../utils/AccessManagement";
import { DrawRequestStore } from "../../../stores/drawRequest/drawRequest.interface";
import {
  getUsername,
  isAMTView,
  isOnlyDrawMember
} from "../../AssetManagement.utils";

export const ExternalDiscussions = ({ drawId }: { drawId: string }) => {
  const dispatch = useDispatch();
  const isOrig = isOrigUser();
  const firstName = Cookies.get("firstName");
  const lastName = Cookies.get("lastName");
  const [discussionChat, setDiscussionChat] = useState<any>({
    userName: "",
    text: "",
    role: ""
  });

  const { drawDetails } = useSelector<RootState, DrawRequestStore>(
    (state) => state.drawRequestStore
  );
  const drawDiscussionsHistory: any[] = useSelector<RootState, any>(
    (state) => state.drawRequestStore.drawDiscussions
  );

  let role: DrawRolesEnum;
  if (isAMTView()) {
    if (isOnlyDrawMember()) {
      role = DrawRolesEnum.DRAW_MEMBER;
    } else {
      role = DrawRolesEnum.DRAW_MANAGER;
    }
  }

  const handleDiscussionsSave = () => {
    const tempDiscussionHistory = JSON.parse(
      JSON.stringify(drawDiscussionsHistory)
    );
    dispatch(
      exportDiscussions(
        discussionChat,
        drawId,
        isOrig,
        tempDiscussionHistory,
        drawDetails.originatorId
      )
    );
    const tempObj = {
      userName: `${firstName} ${lastName}`,
      text: "",
      role
    };
    setDiscussionChat(tempObj);
  };
  const handleDiscussionText = (val: any) => {
    const tempObj = JSON.parse(JSON.stringify(discussionChat));
    tempObj.text = val;
    tempObj.userName = getUsername();
    tempObj.role = role;
    setDiscussionChat(tempObj);
  };
  return (
    <Grid container>
      <DrawDiscussionChat
        drawInternalChats={[]}
        drawDiscussionsHistory={drawDiscussionsHistory}
        handleTextChange={handleDiscussionText}
        handleChatsPost={handleDiscussionsSave}
        chatItem={discussionChat}
        disableChat={drawDetails.stage === DrawStage.draft || isRole(DrawRolesEnum.ORIGINATOR_VIEW_DRAW)}
        btnLabel="Send"
        styleProps={{ height: 1130 }}
      />
    </Grid>
  );
};